import Vue from "vue";
import Router, { RouteConfig, RouterOptions } from "vue-router";

// Main Page Components
import mainView from "../mainView.vue";
import team from "../views/team.vue";
import review from "../views/review/review.vue";
import addTeam from "../views/addTeam.vue";
import addRubric from "../views/addRubric.vue";
import manageRubric from "../views/manageRubric.vue";
import configureReviewers from "../views/review/configureReviewers.vue";
import invite from "../views/invite.vue";

// Review Components
import reviewSession from "../views/review/reviewSession.vue";

// Users Section Components
import users from "../views/users/users.vue";
import user from "../views/users/user.vue";
import addMember from "../views/users/addMember.vue";
import feedback from "../views/users/feedback.vue";
import lessonBuilder from "../views/lessons/lessonBuilder.vue";

// Lessons Section Components
import lessonStats from "../views/lessons/lessonStats.vue";

// Login Components
import login from "../views/login/login.vue";
import subscribe from "../views/login/subscribe.vue";
import Results from "../views/Results.vue";

// Learner View
import LearnerView from "../views/learner/learnerhome.vue";
import LearnerIndex from "../views/learner/learnerindex.vue";
import LearnerWrapper from "../views/learner/resultswrapper.vue";
import ManageSubscription from "../views/learner/managesubscription.vue";

// View Exercise
import ExerciseView from "../views/lessons/exercise.vue";

import JoinTeamView from "../views/joinTeam.vue";

// Error components
import IE from "../views/IE.vue";
import ErrorMobile from "../views/ErrorMobile.vue";
import error404 from "../views/samples/error-pages/error_404.vue";
import error500 from "../views/samples/error-pages/error_500.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "home",
    // redirect: "/learner",
    component: mainView,
    children: [
      {
        path: "/team/:teamID",
        name: "team",
        component: team,
        props: true,
      },
      {
        path: "/review/:teamID",
        name: "review",
        component: review,
        props: true,
      },
      {
        path: "/team/:teamID/users",
        name: "users",
        component: users,
        props: true,
      },
      {
        path: "/team/:teamID/users/add-member",
        name: "addMember",
        component: addMember,
        props: true,
      },
      {
        path: "/team/:teamID/lessons",
        name: "lessonBuilder",
        component: lessonBuilder,
        props: true,
      },
      {
        path: "/team/:teamID/users/user/:userID",
        name: "user",
        component: user,
        props: true,
      },
      {
        path: "/team/:teamID/users/user/:userID/feedback/:sessionID",
        name: "userFeedback",
        redirect: "/review/:teamID/:sessionID/reviewSession",
        component: feedback,
        props: true,
      },
      {
        path: "/team/:teamID/lesson-stats",
        name: "lessonStats",
        component: lessonStats,
        props: true,
      },
      {
        path: "/team/:teamID/add-rubric",
        name: "addRubric",
        component: addRubric,
        props: true,
      },
      {
        path: "/team/:teamID/edit-rubric/:rubricID",
        name: "editRubric",
        component: addRubric,
        props: true,
      },
      {
        path: "/review/:teamID/manage-rubric",
        name: "manageRubric",
        component: manageRubric,
        props: true,
      },
      {
        path: "/review/:teamID/configure-reviewers",
        name: "configureReviewers",
        component: configureReviewers,
        props: true,
      },
      {
        path: "add-team",
        name: "addTeam",
        component: addTeam,
        props: true,
      },
      {
        path: "/review/:teamID/:sessionID/reviewSession",
        name: "reviewSession",
        component: reviewSession,
        props: true,
      },
    ],
  },
  {
    path: "/learner",
    name: "learner",
    redirect: "/learner/home",
    component: LearnerIndex,
    children: [
      {
        path: "subscription",
        name: "manageSubcription",
        component: ManageSubscription,
      },
      {
        path: "home",
        name: "learnerhome",
        component: LearnerView,
      },
      {
        path: "jointeam",
        name: "jointeam",
        component: JoinTeamView,
        props: true,
      },
      {
        path: "lesson/:lid/ex/:eid",
        name: "exercise",
        component: ExerciseView,
        props: true,
      },
      {
        path: "results/:sid",
        name: "learnerresults",
        component: LearnerWrapper,
        props: true,
      },
      {
        path: "/review/:teamID?/:sessionID/reviewSession",
        name: "reviewedSession",
        component: reviewSession,
        props: true,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: login,
    props: true,
  },
  {
    path: "/signup",
    name: "signup",
    component: login,
    props: true,
  },
  {
    path: "/signup/:affiliate",
    name: "signupAffiliate",
    component: login,
    props: true,
  },
  {
    path: "/subscribe",
    name: "subscribe",
    component: subscribe,
    props: true,
  },

  {
    path: "/invite/:inviteID",
    name: "invite",
    component: invite,
  },
  {
    path: "/feedback",
    name: "feedback",
    redirect: (to) => ({ name: "learnerhome", query: { tab: "review" } }),
    component: feedback,
  },
  {
    path: "/feedback/:sessionID",
    name: "feedbackSession",
    redirect: "/review/:teamID?/:sessionID/reviewSession",
    component: feedback,
  },
  {
    path: "/share/:sid",
    name: "shareSession",
    component: LearnerWrapper,
  },
  {
    path: "/notchrome",
    name: "ie",
    component: IE,
  },
  {
    path: "/notdesktop",
    name: "mobile",
    component: ErrorMobile,
  },
  {
    path: "/cleanupcache",
    name: "cleanupcache",
    redirect: "/",
    // component: invite,
  },
  {
    path: "*",
    redirect: "/pages/error_404",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/pages/error_404",
        component: error404,
      },
      {
        path: "/pages/error_500",
        component: error500,
      },
    ],
  },
] as RouteConfig[];

const routerOptions = {
  linkActiveClass: "active",
  mode: "history",
  routes,
} as RouterOptions;

export default new Router(routerOptions);
